import {axiosInstance} from '../helper/appclient'
import get from 'lodash/get'
import {
    MFA_OTP_CODE_VERIFY_URL,
    MFA_SETUP_CODE_VERIFY_URL, VALIDATE_SESSION_URL
} from '../config/url-config'
import {
    ERR_MSG,
    SESS_EXPIRED_TEXT,
    SUCCESS_CODES,
    VAL_TOK_ERR_100,
    VAL_TOK_ERR_101,
    VAL_TOK_ERR_102,
    VAL_TOK_ERR_103, VAL_TOK_ERR_104,
} from "../constants/constants";
import {loadSessionExpired} from "../store/action";
import {store} from "../store/store";
import {extractStatusCode} from "../helper/responsehelper";

export const mfaVerifyTokenResponseStatus = {
    [VAL_TOK_ERR_100]:SESS_EXPIRED_TEXT,
    [VAL_TOK_ERR_101]:SESS_EXPIRED_TEXT,
    [VAL_TOK_ERR_102]:SESS_EXPIRED_TEXT,
    [VAL_TOK_ERR_103]:ERR_MSG,
    [VAL_TOK_ERR_104]:SESS_EXPIRED_TEXT,

    "UNK-ERR-102": ERR_MSG,
};

export const validateSessionService = ()=>{
    return new Promise((resolve,reject)=>{
        axiosInstance
            .get(VALIDATE_SESSION_URL())
            .then((response) => {
                let statusCode =extractStatusCode(response);
                if(SUCCESS_CODES.VAL_SESS_TOKEN.includes(statusCode)){
                    resolve(response)
                }else{
                    let errText = mfaVerifyTokenResponseStatus[statusCode]
                    if(errText === SESS_EXPIRED_TEXT){
                        store.dispatch(loadSessionExpired(true))
                    }
                    reject(errText || ERR_MSG )
                }
            })
            .catch((error) => {
                reject(ERR_MSG)
            });
    })
}